import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) { toast.error(formatErr(err)); } finally { setLoading(false); }
  };
  return (
    <div data-testid="login-page" className="min-h-[80vh] flex items-center px-6 py-16">
      <div className="max-w-md w-full mx-auto sk-card-dark p-10">
        <img src="/assets/sk-logo.jpeg" alt="SK Group" className="w-16 h-16 rounded-full ring-1 ring-[#D4AF37]/40 mx-auto"/>
        <h1 className="font-display text-3xl text-white mt-6 text-center">Welcome back</h1>
        <p className="text-white/50 text-sm text-center mt-1">Login to track your loan applications</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="block">
            <div className="text-xs uppercase tracking-widest text-white/50 mb-2">Email</div>
            <input data-testid="login-email" required type="email" className="sk-input" value={email} onChange={(e)=>setEmail(e.target.value)}/>
          </label>
          <label className="block">
            <div className="text-xs uppercase tracking-widest text-white/50 mb-2">Password</div>
            <input data-testid="login-password" required type="password" className="sk-input" value={password} onChange={(e)=>setPassword(e.target.value)}/>
          </label>
          <button data-testid="login-submit" disabled={loading} className="sk-btn-gold w-full">{loading?"Logging in...":"Login"}</button>
        </form>
        <div className="mt-6 text-center text-sm text-white/60">
          New customer? <Link to="/register" className="text-[#D4AF37] hover:underline">Create account</Link>
        </div>
      </div>
    </div>
  );
}
